import classNames from 'classnames';
import { CompetitorPriceTag } from '../../@types/IPA/GerenciadorDePrecos';
import { Tag, TagProps } from '../Tag';
import styles from './PriceTypeTags.module.scss';

const PRICE_TAG_ORDER: CompetitorPriceTag[] = ['REGULAR', 'OFERTA', 'REBAIXA', 'CLUBE', 'VALIDADE'];

const PRICE_TAG_CONFIG: Record<CompetitorPriceTag, { label: string; skin: TagProps['skin']; outlined?: boolean }> = {
  REGULAR: { label: 'Regular', skin: 'gray' },
  OFERTA: { label: 'Oferta', skin: 'green' },
  REBAIXA: { label: 'Rebaixa', skin: 'orange' },
  CLUBE: { label: 'Clube', skin: 'blue', outlined: true },
  VALIDADE: { label: 'Validade', skin: 'red', outlined: true },
};

export const normalizePriceTags = (priceTags?: string[] | null): CompetitorPriceTag[] => {
  const known = PRICE_TAG_ORDER.filter(tag => priceTags?.includes(tag));
  const promotional = known.filter(tag => tag !== 'REGULAR');
  return promotional.length ? promotional : ['REGULAR'];
};

export type PriceTypeTagsProps = {
  priceTags?: string[] | null;
  className?: string;
};

export const PriceTypeTags = ({ priceTags, className }: PriceTypeTagsProps) => {
  const tags = normalizePriceTags(priceTags);

  return (
    <div
      className={classNames(styles['price-type-tags'], className)}
      title={tags.map(tag => PRICE_TAG_CONFIG[tag].label).join(', ')}
      data-testid="price-type-tags"
    >
      {tags.map(tag => (
        <Tag
          key={tag}
          skin={PRICE_TAG_CONFIG[tag].skin}
          outlined={PRICE_TAG_CONFIG[tag].outlined}
          className={classNames(
            styles['price-type-tags__tag'],
            PRICE_TAG_CONFIG[tag].outlined && styles['price-type-tags__tag--outlined'],
            tag === 'REGULAR' && styles['price-type-tags__tag--regular'],
          )}
        >
          {PRICE_TAG_CONFIG[tag].label}
        </Tag>
      ))}
    </div>
  );
};
